// 数据过滤
const findData = (data, findName) => {
  let findObj = data.find(item => item.position.indexOf(findName) >= 0)
  if (findObj) {
    return findObj
  } else {
    return {}
  }
}
    // 数据过滤
const filterData = (data, filterName, arr) => {
  let findObj = data.filter(item => {
    if (item.position.indexOf(filterName) >= 0) {
      let sortDate = sortObjects(item, arr)
      item.num = sortDate ? sortDate.num : ''
      item.type = sortDate ? sortDate.type : ''
      return item
    }
  })
  if (findObj) {
    return findObj.sort((a, b) => a.num - b.num)
  } else {
    return {}
  }
}
// 排序
const sortObjects = (obj, arr) => {
// 截取
  let objSlice = obj.position.slice(obj.position.lastIndexOf('-') + 1, 100)
  for (let i = 0; i < arr.length; i++) {
    if (objSlice.indexOf(arr[i]) >= 0) {
      let num = i
      if (arr[i] === 'tip') {
        let slicenum = objSlice.slice(3, 4)
        num = i + Number(slicenum)
      }
      if (arr[i] === 'detail') {
        num = 100
      }
      return { num: num, type: arr[i] }
    }
  }
}
export default {
  findData,
  filterData
}
